import AniLink from "gatsby-plugin-transition-link/AniLink"
import React from "react"
import "./style.scss"
import HybridLink from "../utils/HybridLink"

function Footer() {
  const handleNewsletterSubmit = e => {
    e.preventDefault()

    //submission here
  }

  return (
    <div className="">
      <div className="heroBottomWave">
        <img
          loading="lazy"
          src="/images/wave_footer.svg"
          alt="wavefooter"
          width="100%"
          style={{ transform: "rotate(180deg) translateY(-4px)" }}
        />
      </div>
      <div className="footer text-white pb-3">
        <div className="container pt-4">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4 d-flex flex-column importantLinks my-4">
              <AniLink paintDrip hex="#551864" to="/" className="my-1">
                Home
              </AniLink>
              <AniLink paintDrip hex="#551864" to="/getQuote" className="my-1">
                Get Quote
              </AniLink>
              <AniLink paintDrip hex="#551864" to="/services" className="my-1">
                Our Services
              </AniLink>
              <HybridLink
                linkName="Portfolio"
                linkPath="/#portfolio"
                requiredPathname="/"
              />
              {/* <AniLink paintDrip hex="#551864" to="/team" className="my-1">
                Our Core Team
              </AniLink> */}
              <AniLink paintDrip hex="#551864" to="/lab" className="my-1">
                Codefumes Lab
              </AniLink>
              <AniLink paintDrip hex="#551864" to="/blog" className="my-1">
                Our Blog
              </AniLink>
              <HybridLink
                linkName="Contact"
                linkPath="/#letstalk"
                requiredPathname="/"
              />
            </div>
            <div className="col-12 col-sm-6 col-md-4 my-4">
              <div className="fs-4 mb-1">Newsletter</div>
              <p className="mb-2">
                Subscribe to our newsletter to recieve exclusive limited time
                offers for your projects
              </p>
              <form onSubmit={e => handleNewsletterSubmit(e)}>
                <div className="form-floating mb-3" style={{ color: "black" }}>
                  <input
                    type="text"
                    className="form-control"
                    id="footerSubscribe__email"
                    placeholder="Name"
                    style={{ borderRadius: "18px", boxShadow: "none" }}
                    required
                  />
                  <label htmlFor="footerSubscribe__email">Email</label>
                </div>
                <input
                  type="submit"
                  className="btn footerSubscribeBtn"
                  placeholder="Name"
                  value="Subscribe 😄"
                  required
                />
              </form>
            </div>
            <div className="col-12 col-md-4 my-4">
              <br />
              <div className="d-flex justify-content-center align-items-start">
                <a
                  href="https://instagram.com/codefumes"
                  target="_blank"
                  rel="noreferrer"
                  className="socialBtn fs-3"
                >
                  <i className="bi bi-instagram"></i>
                </a>
                <a
                  href="https://www.facebook.com/codefumesofficial"
                  target="_blank"
                  rel="noreferrer"
                  className="socialBtn fs-3"
                >
                  <i className="bi bi-facebook"></i>
                </a>
                <a
                  href="https://github.com/codefumes"
                  target="_blank"
                  rel="noreferrer"
                  className="socialBtn fs-3"
                >
                  <i className="bi bi-github"></i>
                </a>
                <a
                  href="mailto:info@codefumes.com"
                  className="socialBtn fs-3"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="bi bi-envelope-fill"></i>
                </a>
              </div>
              <br />
              <div
                className="fs-5 text-center"
                style={{ letterSpacing: "2px" }}
              >
                info@codefumes.com
              </div>
            </div>
            <div
              className="col-12 text-center mt-5"
              style={{ letterSpacing: "1.3px" }}
            >
              &copy; {new Date().getFullYear()}{" "}
              <AniLink
                paintDrip
                hex="#551864"
                to="/"
                className="fw-bold"
                style={{ color: "#fcba9e" }}
              >
                Codefumes
              </AniLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
